import {
  SHOP_MAX_NAME_LENGTH,
  SHOP_MAX_ALT_NAME_LENGTH,
  SHOP_MAX_DESCRIPTION_LENGTH,
  SHOP_MAX_ADDRESS_DETAIL_LENGTH,
  SHOP_MAX_ACCESS_NAME_LENGTH,
} from '../../../lib/constants.js.erb';

$(() => {
  $('.js-validate-form-shop').validate({
    rules: {
      'shop[name]': {
        required: true,
        maxlength: SHOP_MAX_NAME_LENGTH,
      },
      'shop[alt_name]': {
        maxlength: SHOP_MAX_ALT_NAME_LENGTH,
      },
      'shop[postal_city_id]': {
        required: true,
      },
      'shop[address_detail]': {
        maxlength: SHOP_MAX_ADDRESS_DETAIL_LENGTH,
      },
      'shop[access_name]': {
        maxlength: SHOP_MAX_ACCESS_NAME_LENGTH,
      },
      'shop[description]': {
        maxlength: SHOP_MAX_DESCRIPTION_LENGTH,
      },
      'shop[average_age]': {
        range: [16, 90],
      },
      'shop[male_rate]': {
        range: [0, 10],
      },
    },
  });
});
